export const defaultImage = `${location.origin}/assets/placeholder.png`;
